export enum FormAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}
